import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { plicks } from "../../../api/fileApi"
import {push} from "connected-react-router";

export default function* plickSaga() {
  yield all([
    fork(watchFetchPlicksRequest),
    fork(watchFetchPlicksPageRequest)
  ]);
}

function* watchFetchPlicksRequest() {
  yield takeLatest(
    actions.FETCH_PLICKS_REQUEST,
    fetchPlickRequest
  )
}

function* fetchPlickRequest(file) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(plicks, file.value.file,file.value.bankId,file.value.page,file.value.size)
    yield put({ type: actions.FETCH_PLICKS_SUCCESS, plicks: data })
    yield put({type:actions.SET_FILE_BANK_ID,value:{bankId:file.value.bankId,fileId:file.value.file}})
    yield put(push(`/file/${file.value.file}/plick`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_PLICKS_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchFetchPlicksPageRequest() {
  yield takeLatest(
      actions.FETCH_PLICKS_PAGE_REQUEST,
      fetchPlickPageRequest
  )
}

function* fetchPlickPageRequest(file) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(plicks, file.value.file,file.value.bankId,file.value.page,file.value.size)

    yield put({ type: actions.FETCH_PLICKS_SUCCESS, plicks: data })
    // yield put({type:actions.SET_FILE_BANK_ID,value:file.value.bankId})
    // yield put(push(`/file/${file.value.file}/plick`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_PLICKS_PAGE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}